// extracted by mini-css-extract-plugin
export default {"editCustomPlanButton":"EditCustomPlanButton_editCustomPlanButton__Xi7B0","addProjectButton":"EditCustomPlanButton_addProjectButton__xv0b+"};